import { network } from 'services/network';

export const getSubProgramPreferenceInfo = () => {
    return network.get('api/bo/getSubProgramPreferenceInfo').then((response) => {
        return response.data;
    });
};
